import DayjsUtils from "@date-io/dayjs";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createTheme } from "@material-ui/core/styles";
import {
  DatePicker as MuiDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { ThemeProvider } from "@material-ui/styles";
import dayjs from "dayjs";
import React, { useRef } from "react";

const green = {
  50: "#74b44a",
  100: "#74b44a",
  200: "#74b44a",
  300: "#74b44a",
  400: "#74b44a",
  500: "#74b44a",
  600: "#74b44a",
  700: "#74b44a",
  800: "#74b44a",
  900: "#74b44a",
  A100: "#74b44a",
  A200: "#74b44a",
  A400: "#74b44a",
  A700: "#74b44a",
};

const defaultMaterialTheme = createTheme({
  palette: {
    primary: green,
  },
});

export default function DatePicker({
  value,
  setValue,
  label,
  iconStyle,
  iconPosition = "start", // 'start' or 'end'
  disabled = false,
}) {
  const ref = useRef(null);
  const showLabel = Boolean(label);

  return (
    <>
      <div
        className={`float-label ${
          disabled ? "disable-time" : "cursor-pointer-all"
        } pointer-wrap`}
        onClick={() => ref.current.click()}
        style={{
          position: "relative",
        }}
      >
        {showLabel && (
          <label
            style={{ paddingLeft: value ? "20px" : "40px" }}
            className={value ? "Active input-field" : "input-field"}
          >
            {label}
          </label>
        )}

        {/* Left icon */}
        {iconPosition === "start" && (
          <FontAwesomeIcon
            style={{
              position: "absolute",
              top: showLabel ? `calc(50% - ${value ? "0px" : "7px"})` : "50%",
              left: "15px",
              transform: showLabel ? "none" : "translateY(-50%)",
              cursor: "pointer",
              color: "#2F481E",
              ...iconStyle,
            }}
            icon={faCalendar}
          />
        )}

        <input
          style={{
            paddingLeft: showLabel && "40px",
            paddingRight: iconPosition === "end" ? "40px" : "16px",
            paddingTop: showLabel ? "17px" : "0",
            pointerEvents: "none",
          }}
          className="form-control"
          onClick={(e) => e.preventDefault()}
          value={value ? dayjs(value).format("MM/DD/YY") : ""}
          type="text"
          disabled={disabled}
          readOnly
        />

        {/* Right icon */}
        {iconPosition === "end" && (
          <FontAwesomeIcon
            style={{
              position: "absolute",
              top: showLabel ? `calc(50% - ${value ? "0px" : "7px"})` : "50%",
              right: "15px",
              transform: showLabel ? "none" : "translateY(-50%)",
              cursor: "pointer",
              color: "#2F481E",
              ...iconStyle,
            }}
            icon={faCalendar}
          />
        )}
      </div>

      <MuiPickersUtilsProvider utils={DayjsUtils}>
        <ThemeProvider theme={defaultMaterialTheme}>
          <MuiDatePicker
            inputRef={ref}
            style={{ visibility: "hidden", position: "absolute" }}
            format="DD/MM/YYYY"
            label=""
            value={value}
            onChange={setValue}
            disabled={disabled}
          />
        </ThemeProvider>
      </MuiPickersUtilsProvider>
    </>
  );
}
